webpackJsonp([233698595820445],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rf = __webpack_require__(452);
	
	var _rf2 = _interopRequireDefault(_rf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Step 3: Learn about Random Forest'
	        ),
	        _react2.default.createElement(
	          'progress',
	          { value: '60', max: '100' },
	          '60 %'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Random Forest is a way for computers to make decisions by using multiple helpers called decision trees. A decision tree is like a flowchart that sorts information step by step. The image below shows how decision trees work together to make a decision.'
	        ),
	        _react2.default.createElement('img', { src: _rf2.default, alt: 'Image1', style: { width: '300px', height: 'auto' } }),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Worrying about writing code? We\'ve done it for you! Now you can run Google Colab below to see the results on a new batch of candidates. After you go to Google Colab, select "Runtime->Run all".'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://colab.research.google.com/drive/1iIlMPTs0mqySoxUt2kOkTqgjzEWzFOBq?usp=sharing', title: 'Colab', target: '_blank' },
	            'Colab'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* If you selected Dataset1 before, the results are shown under the section Training With Dataset1. If you selected Dataset2 before, the results are shown under the section Training With Dataset2. Any biases identified in the results? Did you make the right choice?'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/2-acquire/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/4-clean/' },
	          'Next step'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rf.548a44e9.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-3-rf-js-9695e741bc0774dd01fc.js